// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"158":"labels","496":"campaigns","644":"account","721":"inbox","806":"user"}[chunkId] + "." + {"158":"661e77fd7b0af1db52a0","496":"5399bcb9eabf917cf1c5","644":"a242b2449cbe8a9b2d6a","721":"b1ea11091da3dc3ccdcb","806":"e1426a4fb214d7602864"}[chunkId] + ".js";
};